exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox[data-v-ca928be0] {\n  margin-bottom: 1rem;\n}\n.checkbox input[data-v-ca928be0] {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.check-label[data-v-ca928be0] {\n  line-height: 1rem;\n}\n.check-icon[data-v-ca928be0] {\n  padding: 0.375rem 0.75rem;\n}", ""]);

// exports
